export default "__VITE_ASSET__CxvNCSJG__"